import { render, staticRenderFns } from "./CustomPayment-Accelerant-60-Ax.vue?vue&type=template&id=58622f40&scoped=true&"
import script from "./CustomPayment-Accelerant-60-Ax.vue?vue&type=script&lang=js&"
export * from "./CustomPayment-Accelerant-60-Ax.vue?vue&type=script&lang=js&"
import style0 from "./CustomPayment-Accelerant-60-Ax.vue?vue&type=style&index=0&id=58622f40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58622f40",
  null
  
)

export default component.exports